/* eslint-disable no-prototype-builtins */
/* eslint-disable indent */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable no-unused-expressions */
import {
  Button as MaterialButton,
  Grid,
  InputAdornment,
  InputBase,
  makeStyles,
  Menu,
  MenuItem,
  Paper,
  TextField,
  Typography,
  Tooltip,
  Box,
  CircularProgress,
} from '@material-ui/core';
import FilterListRoundedIcon from '@material-ui/icons/FilterListRounded';

import { connect } from 'react-redux';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import CheckIcon from '@material-ui/icons/Check';
import React from 'react';
import i18n from 'i18n';
import Button from 'components/Button';
import { FilterFields } from 'modules/filters/interfaces';
import { setFilterValues } from 'modules/filters/actions';
import { Query } from 'hooks/useTableFilters';
import { cyrb53Hash } from 'utils/helpers';
import palette from 'theme/palette';
import ApplicationState from 'store/interfaces';
import clsx from 'clsx';
import styles from './styles';

export interface DynamicFilterProps {
  isLoading: boolean;
  listSwitch?: boolean;
  searchValue: string;
  itemsCountFiltered?: number;
  filters: FilterFields[];
  noSwitchList?: boolean;
  searchPlaceholder?: string;
  itemsCountTotal?: number;
  action?: React.ReactNode;
  itemsTotalText?: string;
  getItemsNoFilters?: () => void;
  handleGetItems?: (search: string) => void;
  handleSearch: (search: string) => void;
  setSearchValue: (value: React.SetStateAction<string>) => void;
  setListSwitch?: (value: React.SetStateAction<boolean>) => void;
  setQuery: (value: React.SetStateAction<Query>) => void;
  setFilterValues: (props: FilterFields[]) => void;
}

const DynamicFilter = ({
  isLoading,
  listSwitch,
  searchValue,
  noSwitchList,
  searchPlaceholder,
  itemsCountFiltered,
  filters,
  itemsCountTotal,
  action,
  itemsTotalText,
  getItemsNoFilters,
  handleGetItems,
  setSearchValue,
  handleSearch,
  setListSwitch,
  setQuery,
  setFilterValues,
}: DynamicFilterProps) => {
  const classes = makeStyles(styles)();

  const visibleFilters = filters?.map(item => {
    if (!item?.hasOwnProperty('value')) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { isChecked, ...rest } = item;
      return rest;
    }
    return item;
  });
  React.useEffect(() => {
    setFilterValues(visibleFilters);
  }, []);

  const createUpdatedFilters = (isChecked: boolean) =>
    visibleFilters?.map(item => ({
      ...item,
      isChecked,
      value: '',
    }));

  const [finalValue, setFinalValue] = React.useState<FilterFields[]>(
    visibleFilters
  );

  const handleFilterUpdate = (updatedFilters: FilterFields[]) => {
    setFilterValues(updatedFilters);
    setFinalValue(updatedFilters);
  };

  React.useEffect(() => {
    handleFilterUpdate(filters);
  }, [filters]);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const countCheckedTrue = filters?.filter(item => item.isChecked).length;

  const handleMenuItemClick = (index: number) => {
    const updatedFilters = [...filters];
    updatedFilters[index].isChecked = !updatedFilters[index].isChecked;
    handleFilterUpdate(updatedFilters);
  };

  const handleMenuItemClickOption = (value: string, index: number) => {
    const updatedFilters = [...filters];
    updatedFilters[index].value = value;
    handleFilterUpdate(updatedFilters);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleValueChange = (
    key: string,
    newValue: string,
    isChecked?: boolean
  ) => {
    const updatedFilters = finalValue?.map(filter =>
      filter.key === key
        ? {
            ...filter,
            value: newValue,
            ...(isChecked !== undefined ? { isChecked } : {}),
          }
        : filter
    );
    setFinalValue(updatedFilters);
  };

  const [triggerUpdate, setTriggerUpdate] = React.useState<boolean>(false);

  React.useEffect(() => {
    setFilterValues(finalValue);
  }, [triggerUpdate]);

  const [isSearchLocked, setIsSearchLocked] = React.useState(false);

  const initiateSearch = (searchTerm: string) => {
    if (isSearchLocked || isLoading) return;
    setIsSearchLocked(true);

    handleSearch(searchTerm);
    handleGetItems?.(searchTerm);
    setListSwitch?.(true);

    setTimeout(() => {
      setIsSearchLocked(false);
    }, 150);
  };

  return (
    <Grid container className={classes.container}>
      <Grid container spacing={3} className={classes.searchContainer}>
        <Grid
          item
          className={clsx({
            [classes.searchBarNoSwitch]: !noSwitchList && !setListSwitch,
            [classes.searchBar]: !noSwitchList,
            [classes.searchBarNoExport]: !action,
          })}
        >
          <Paper component="form" className={classes.search}>
            <SearchIcon className={classes.searchIcon} />
            <InputBase
              id="search-items"
              autoFocus
              placeholder={searchPlaceholder || i18n.t('SEARCH_KEY')}
              className={classes.searchInput}
              onChange={({ target }) => setSearchValue(target.value)}
              onKeyPress={e => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  initiateSearch(searchValue);
                }
              }}
            />
          </Paper>
        </Grid>
        <Grid
          item
          className={clsx({
            [classes.buttonsGridNoSwitchList]: !noSwitchList && !setListSwitch,
            [classes.buttonsGrid]: !noSwitchList,
            [classes.buttonsGridWithAction]: !noSwitchList && !!action,
          })}
        >
          <MaterialButton
            aria-controls="filter-menu"
            variant="outlined"
            className={classes.mainButton}
            aria-haspopup="true"
            onClick={handleClick}
            startIcon={<FilterListRoundedIcon />}
          >
            <Typography className={classes.dynamicButtonText}>
              {i18n.t('DYNAMIC_FILTER.FILTER_BUTTON_KEY')}
            </Typography>
            {countCheckedTrue > 0 && (
              <Grid className={classes.filterCount}>{countCheckedTrue}</Grid>
            )}
          </MaterialButton>

          <Button
            id="search-all-items"
            variant="outlined"
            onClick={() => {
              initiateSearch(searchValue);
              setFilterValues(finalValue);
            }}
            disabled={isLoading || isSearchLocked}
          >
            <Typography className={classes.listAll}>
              {i18n.t('SEARCH_ALL_KEY')}
            </Typography>
          </Button>
          {!noSwitchList && setListSwitch && (
            <Button
              className={classes.listButtonSize}
              id="list-all-items"
              variant="outlined"
              pressed={listSwitch}
              onClick={() => {
                setListSwitch(!listSwitch);
                setQuery(prev => ({ ...prev, offset: 0, limit: 25 }));
              }}
              disabled={isLoading}
            >
              <Typography className={classes.listAll}>
                {i18n.t('LIST_ALL_KEY')}
              </Typography>
            </Button>
          )}
          {action}
        </Grid>
      </Grid>
      <Grid>
        <Menu
          id="filter-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem
            className={classes.selectAllButton}
            onClick={() => {
              handleFilterUpdate(createUpdatedFilters(true));
              handleClose();
            }}
          >
            <PlaylistAddCheckIcon className={classes.iconCheck} />
            <Typography className={classes.selectAll} variant="body2">
              {i18n.t('DYNAMIC_FILTER.SELECT_ALL_KEY')}
            </Typography>
          </MenuItem>
          <MenuItem
            className={classes.removeAllButton}
            onClick={() => {
              handleFilterUpdate(createUpdatedFilters(false));
              getItemsNoFilters?.();
              handleClose();
            }}
          >
            <DeleteSweepIcon className={classes.iconRemoveAll} />
            <Typography className={classes.removeAll} variant="body2">
              {i18n.t('DYNAMIC_FILTER.CLEAN_ALL_KEY')}
            </Typography>
          </MenuItem>
          <Grid className={classes.divider}></Grid>
          {filters?.map((option: FilterFields, index: number) => (
            <MenuItem
              key={option?.key}
              onClick={() => {
                if (option?.isChecked) {
                  handleValueChange(option?.key, '');
                }

                handleMenuItemClick(index);
                handleClose();
              }}
            >
              {option?.isChecked && <CheckIcon className={classes.iconCheck} />}
              <Typography variant="body2">{i18n.t(option?.label)}</Typography>
            </MenuItem>
          ))}
        </Menu>
      </Grid>
      <Grid container>
        {countCheckedTrue > 0 && (
          <Grid
            container
            alignItems="center"
            justify="space-between"
            className={classes.filterOptions}
          >
            <Grid item className={classes.displayFlex}>
              {!!itemsCountTotal && !!itemsCountFiltered && (
                <>
                  {isLoading ? (
                    <CircularProgress style={{ marginLeft: 4 }} size={10} />
                  ) : (
                    <>
                      <Typography style={{ fontSize: 12 }}>
                        {`${itemsTotalText}:`}
                        <Box
                          color={palette.blue}
                          fontSize={12}
                          fontWeight="bold"
                          display="inline"
                          style={{ marginLeft: 4 }}
                        >
                          {itemsCountTotal}
                        </Box>
                      </Typography>
                      <Typography style={{ margin: '0px 4px' }} variant="body2">
                        {'/'}
                      </Typography>
                      <Typography style={{ fontSize: 12 }}>
                        {`${i18n.t('FILTERED_TOTAL_KEY')}:`}

                        <Box
                          fontSize={12}
                          color={palette.blue}
                          fontWeight="bold"
                          display="inline"
                          style={{ marginLeft: 4 }}
                        >
                          {itemsCountFiltered || 0}
                        </Box>
                      </Typography>
                    </>
                  )}
                </>
              )}
            </Grid>
            <Grid item>
              <MaterialButton
                className={classes.cleanButton}
                onClick={() => {
                  handleFilterUpdate(createUpdatedFilters(false));
                  getItemsNoFilters?.();
                  handleClose();
                }}
                startIcon={<DeleteSweepIcon className={classes.cleanIcon} />}
              >
                {i18n.t('DYNAMIC_FILTER.CLEAN_FILTERS_KEY')}
              </MaterialButton>
            </Grid>
          </Grid>
        )}
      </Grid>

      <Grid container>
        {filters?.map((option: FilterFields) => {
          const correspondingValue =
            finalValue?.find(filter => filter?.key === option?.key)?.value ||
            '';

          return (
            <Grid item key={option?.key} className={classes.item}>
              {option?.isChecked && (
                <Grid item className={classes.textFieldGrid}>
                  <Tooltip arrow title={i18n.t(option?.label)} placement="left">
                    <TextField
                      autoFocus
                      className={classes.textField}
                      fullWidth
                      select={option?.isSelect}
                      variant="outlined"
                      label={
                        <Typography className={classes.optionSelected}>
                          {i18n.t(option?.label)}
                        </Typography>
                      }
                      value={correspondingValue}
                      onKeyPress={e => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          initiateSearch(searchValue);
                        }
                      }}
                      onChange={({ target }) => {
                        handleValueChange(option?.key, target.value);
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            onClick={() => {
                              handleValueChange(option?.key, '', false);
                              setTriggerUpdate(true);
                            }}
                          >
                            <CloseIcon className={classes.closeIcon} />
                          </InputAdornment>
                        ),
                      }}
                    >
                      {option?.selectType?.map((option, index) => (
                        <MenuItem
                          key={cyrb53Hash(String(index))}
                          value={option?.key}
                          onClick={() => {
                            handleMenuItemClickOption(option?.key, index);
                            handleClose();
                          }}
                        >
                          <Typography className={classes.optionSelected}>
                            {i18n.t(option?.label)}
                          </Typography>
                        </MenuItem>
                      ))}
                    </TextField>
                  </Tooltip>
                </Grid>
              )}
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

const mapStateToProps = ({ filters: { filters } }: ApplicationState) => ({
  filters,
});

export default connect(mapStateToProps, {
  setFilterValues,
})(DynamicFilter);
